import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Check/check';
import { css } from '@patternfly/react-styles'; // tslint:disable-next-line:no-empty

var defaultOnChange = function defaultOnChange() {};

export var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).call(this, props));

    _this.handleChange = function (event) {
      _this.props.onChange(event.currentTarget.checked, event);
    };

    return _this;
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          ariaLabel = _a['aria-label'],
          className = _a.className,
          onChange = _a.onChange,
          isValid = _a.isValid,
          isDisabled = _a.isDisabled,
          isChecked = _a.isChecked,
          label = _a.label,
          checked = _a.checked,
          defaultChecked = _a.defaultChecked,
          description = _a.description,
          props = __rest(_a, ['aria-label', "className", "onChange", "isValid", "isDisabled", "isChecked", "label", "checked", "defaultChecked", "description"]);

      var checkedProps = {};

      if ([true, false].includes(checked) || isChecked === true) {
        checkedProps.checked = checked || isChecked;
      }

      if (onChange !== defaultOnChange) {
        checkedProps.checked = isChecked;
      }

      if ([false, true].includes(defaultChecked)) {
        checkedProps.defaultChecked = defaultChecked;
      }

      checkedProps.checked = checkedProps.checked === null ? false : checkedProps.checked;
      return React.createElement("div", {
        className: css(styles.check, className)
      }, React.createElement("input", Object.assign({}, props, {
        className: css(styles.checkInput),
        type: "checkbox",
        onChange: this.handleChange,
        "aria-invalid": !isValid,
        "aria-label": ariaLabel,
        disabled: isDisabled,
        ref: function ref(elem) {
          return elem && (elem.indeterminate = isChecked === null);
        }
      }, checkedProps)), label && React.createElement("label", {
        className: css(styles.checkLabel, isDisabled && styles.modifiers.disabled),
        htmlFor: props.id
      }, label), description && React.createElement("div", {
        className: css(styles.checkDescription)
      }, description));
    }
  }]);

  return Checkbox;
}(React.Component);
Checkbox.defaultProps = {
  className: '',
  isValid: true,
  isDisabled: false,
  isChecked: false,
  onChange: defaultOnChange
};